module.exports = __webpack_public_path__ + "media/images/content_marketing_check-594e13cf4d2bb089e7b38fdf45ae25f5.svg";